<ng-template #links>
  <span class="navbar-text d-none d-md-flex">
    <div>
      <a class="small me-1" routerLink="/legal/terms">
        <span i18n>Terms</span>
      </a>
      |
      <a class="small me-1" routerLink="/legal/privacy">
        <span i18n>Privacy</span>
      </a>
      |
      <a class="small me-1" href="{{ GITHUB_URL }}" target="blank">
        <span>Github</span>
      </a>
      |
      <a class="small me-1" href="{{ BLOG_URL }}" target="blank">
        <span i18n>Blog</span>
      </a>
      |
      <a class="small me-1" href="{{ KB_URL_HOME }}" target="blank">
        <span i18n>Help</span>
      </a>
      |
      <a class="small me-1" routerLink="/pricing">
        <span i18n="@@pricing">Pricing</span>
      </a>
    </div>
  </span>

  <span class="navbar-text text-muted">
    <small>
      <ng-container i18n>Copyright</ng-container>
      <span>&nbsp;</span>
      <i class="far fa-copyright" aria-hidden="true"></i>
      {{ today | date : 'yyyy' }} Maptio Ltd
    </small>
  </span>
</ng-template>

<nav
  [class.flex-column]="isMobile"
  [class.flex-row]="!isMobile"
  [class.text-white]="isMobile"
  [class.text-muted]="!isMobile"
  class="footer navbar bg-transparent d-flex justify-content-center justify-content-md-between col-11"
>
  <ng-container *ngTemplateOutlet="links"></ng-container>
</nav>
